import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";

const BarraNavegacion = ({ titulo, onLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  /* =======================
     MENÚ INFORMES
  ======================= */
  const [anchorElInformes, setAnchorElInformes] = useState(null);
  const openInformes = Boolean(anchorElInformes);

  const handleMenuInformesClick = (event) =>
    setAnchorElInformes(event.currentTarget);
  const handleMenuInformesClose = () =>
    setAnchorElInformes(null);

  /* =======================
     MENÚ DEFINICIONES
  ======================= */
  const [anchorElDefiniciones, setAnchorElDefiniciones] = useState(null);
  const openDefiniciones = Boolean(anchorElDefiniciones);

  const handleMenuDefinicionesClick = (event) =>
    setAnchorElDefiniciones(event.currentTarget);
  const handleMenuDefinicionesClose = () =>
    setAnchorElDefiniciones(null);

  const handleNavigate = (path) => {
    handleMenuInformesClose();
    handleMenuDefinicionesClose();
    navigate(path);
  };

  /* =======================
     OPCIONES
  ======================= */
  const opcionesMenuDefiniciones = [
    { label: "Almacenes", path: "/Almacenes" },
    { label: "Buques", path: "/Buques" },
    { label: "Clientes", path: "/Clientes" },
    { label: "Consignatarios", path: "/Consignatarios" },
    { label: "Jornadas", path: "/Jornadas" },
    { label: "Medios Mecánicos", path: "/MediosMecanicos" },
    { label: "Mercancías", path: "/Mercancias" },
    { label: "Operativas", path: "/Operativas" },
    { label: "Origen / Destino", path: "/OrigenDestino" },
    { label: "Costes Directos", path: "/CostesDirectos" },
    { label: "Colla", path: "/Colla" },
    { label: "Personal 1ª Linea", path: "/PersonalPrimeraLinea" },
    { label: "Personal 2ª Linea", path: "/PersonalSegundaLinea" },
    { label: "Pluses", path: "/Pluses" },
    { label: "Proveedores", path: "/Proveedores" },
    { label: "Tarifas", path: "/Tarifas" },
  ];

  const opcionesMenuInformes = [
    { label: "Arrastres", path: "/Informes/Arrastres" },   
    { label: "Costes Directos", path: "/Informes/CostesDirectos" },   
    { label: "Maquinaria", path: "/Informes/Maquinaria" },
    { label: "Personal (Agrupado)", path: "/Informes/PersonalAgrupado" },
    { label: "Personal (Individual)", path: "/Informes/PersonalIndividual" },
    { label: "Por Jornada", path: "/Informes/PorJornada" },
    { label: "Por Operación", path: "/Informes/PorOperacion" },
    { label: "Tasas", path: "/Informes/Tasas" },
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          {isMobile ? "CDV" : titulo || "Cargas y Descargas Velasco S.A."}
        </Typography>

        <Button color="inherit" component={Link} to="/">
          Dashboard
        </Button>

        <Button color="inherit" component={Link} to="/Operaciones">
          {isMobile ? "Ops" : "Operaciones"}
        </Button>

        {/* =======================
            INFORMES
        ======================= */}
        <Button color="inherit" onClick={handleMenuInformesClick}>
          Informes
        </Button>

        <Menu
          anchorEl={anchorElInformes}
          open={openInformes}
          onClose={handleMenuInformesClose}
        >
          {opcionesMenuInformes.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>

        {/* =======================
            DEFINICIONES
        ======================= */}
        <Button color="inherit" onClick={handleMenuDefinicionesClick}>
          {isMobile ? "Def" : "Definiciones"}
        </Button>

        <Menu
          anchorEl={anchorElDefiniciones}
          open={openDefiniciones}
          onClose={handleMenuDefinicionesClose}
        >
          {opcionesMenuDefiniciones.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <Button color="inherit" onClick={onLogout}>
          {isMobile ? <LogoutIcon /> : "Logout"}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default BarraNavegacion;
